import { theme } from '../globalStyle/global-styles';
import styled from 'styled-components';

export const LabelAndDescWrapper = styled.div<{ direction: 'column' | 'row' }>`
  display: flex;
  justify-content: flex-start;
  align-items: ${(props) =>
    props.direction === 'column' ? 'flex-start' : 'center'};
  gap: ${theme.space_size};
  flex-direction: ${(props) =>
    props.direction === 'column' ? 'column' : 'row'};
  p {
    line-height: 22px;
    &:first-child {
      color: ${theme.colours.PhilippineSilver};
      font-family: ${theme.fonts.Regular};
      font-size: 14px;
      min-width: 90px;
    }
    &:last-child {
      direction: ltr;
      color: ${theme.colours.DavysGrey};
      font-family: ${theme.fonts.Medium};
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;
